import { gql } from '@apollo/client';
import { removeTypeNameFromObject } from 'spw-shared/utils';
import { ITotalProgram, UsfType } from 'spw-redux/modules/calculators/types';
import { graphqlClient } from './utils';
import { SCENARIO_FIELDS } from './fragments';

export const fetchTotalPrograms = (projectId: number) =>
  graphqlClient.query({
    fetchPolicy: 'no-cache',
    query: gql`
      query FetchTotalPrograms {
        totalPrograms(projectId: ${projectId}) {
          id
          index
          name
          subtotalProgramMultiplier
          planningFactor
          usf
          usfType
          totalProgramScenario {
            id
            scenarioId
            totalProgramId
          }
          notes {
            id
            note
            category
          }
        }
      }`,
  });

export const getTotalProgram = (totalProgramId: number) => {
  return graphqlClient.query<{ totalProgram: ITotalProgram }>({
    fetchPolicy: 'no-cache',
    query: gql`
    ${SCENARIO_FIELDS}
      query GetTotalProgram{
        totalProgram: getTotalProgram(totalProgramId: ${totalProgramId}) {
          id
          index
          name
          subtotalProgramMultiplier
          planningFactor
          usf
          usfType
          projectId
          totalProgramScenario {
            id
            scenarioId
            totalProgramId
            scenario {
              ...ScenarioFields
            }
          }
          notes {
            id
            note
            category
          }
        }
      }
    `,
  });
};

export const updateTotalProgram = (totalProgram: {
  id: number;
  name: string;
  index?: number;
  subtotalProgramMultiplier?: number;
  planningFactor?: number;
  usf?: number;
  usfType?: UsfType;
  totalProgramScenario?: { totalProgramId: number; scenarioId: number }[];
}) => {
  return graphqlClient.mutate<{ totalProgram: ITotalProgram }>({
    mutation: gql`
      mutation UpdateTotalProgram($totalProgram: TotalProgramArgs!) {
        totalProgram: updateTotalProgram(totalProgram: $totalProgram) {
          id
          index
          name
          subtotalProgramMultiplier
          planningFactor
          usf
          usfType
          totalProgramScenario {
            id
            scenarioId
            totalProgramId
          }
        }
      }
    `,
    variables: {
      totalProgram: removeTypeNameFromObject(totalProgram),
    },
  });
};

export const deleteTotalProgram = (totalProgramId: number) =>
  graphqlClient.query({
    fetchPolicy: 'no-cache',
    query: gql`
      mutation DeleteTotalProgram($totalProgramId: ID!) {
        deleteTotalProgram(id: $totalProgramId) {
          id
          name
          index
        }
      }
    `,
    variables: {
      totalProgramId,
    },
  });
